<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  [formCtrl]="formCtrl"
></kodit-dropdown>
